import { motion } from "framer-motion";
import {
  ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, Radar,
} from "recharts";
import { DOMAINS } from "../data/site";

const overall = (DOMAINS.reduce((a, d) => a + d.score, 0) / DOMAINS.length).toFixed(1);
const radarData = DOMAINS.map((d) => ({ domain: d.key.split(" ")[0], score: d.score }));

function Bar({ label, score, delay }) {
  const pct = (score / 5) * 100;
  return (
    <div data-testid={`scorecard-bar-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex justify-between items-baseline mb-1.5">
        <span className="text-[13px] font-medium text-charcoal">{label}</span>
        <span className="text-[13px] font-semibold text-ink tabular-nums">{score.toFixed(1)}</span>
      </div>
      <div className="h-2 bg-surface border border-border rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-ink rounded-full"
          initial={{ width: "0%" }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: delay + 0.2 }}
        />
      </div>
    </div>
  );
}

export default function Scorecard({ compact = false }) {
  return (
    <div
      data-testid="scorecard-dashboard"
      className="bg-white border border-border rounded-2xl shadow-[0_20px_60px_-30px_rgba(11,31,51,0.25)] overflow-hidden"
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-border bg-surface">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-ink" />
          <span className="text-[13px] font-semibold text-ink tracking-tight">Executive Business Health Scorecard</span>
        </div>
        <span className="text-[11px] text-steel uppercase tracking-widest">Sample</span>
      </div>

      <div className={`grid ${compact ? "md:grid-cols-2" : "lg:grid-cols-2"} gap-8 p-6 lg:p-8`}>
        <div className="flex flex-col">
          <div className="flex items-end gap-3 mb-4">
            <span className="font-serif text-6xl leading-none text-ink">{overall}</span>
            <span className="text-steel text-sm mb-1.5">/ 5.0 overall maturity</span>
          </div>
          <div className="flex-1 min-h-[240px]">
            <ResponsiveContainer width="100%" height={260}>
              <RadarChart data={radarData} outerRadius="72%">
                <PolarGrid stroke="#D0D6DC" />
                <PolarAngleAxis dataKey="domain" tick={{ fill: "#4A657A", fontSize: 11 }} />
                <Radar dataKey="score" stroke="#0B1F33" fill="#0B1F33" fillOpacity={0.12} strokeWidth={2} />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="space-y-4">
          {DOMAINS.map((d, i) => (
            <Bar key={d.key} label={d.key} score={d.score} delay={i * 0.06} />
          ))}
        </div>
      </div>
    </div>
  );
}
